"use client";

import React, { useState } from "react";

import { parseParamsForHubspot, submitFormData } from "@stadium/services/hubspot";

import { isEmail } from "@stadium/helpers/form/validation";

const NEWSLETTER_FORM_GUID = process.env.NEXT_PUBLIC_HUBSPOT_NEWSLETTER_FORM_GUID || "";

const NEWSLETTER_HUBSPOT_MAPPING: Record<string, string> = { email: "email" };

const NEWSLETTER_PAGE_NAME = "Newsletter";

export const useNewsletter = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    if (isSubmitting || !NEWSLETTER_FORM_GUID) return;

    if (!email || !isEmail(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    try {
      const params = parseParamsForHubspot(
        NEWSLETTER_HUBSPOT_MAPPING,
        { email },
        NEWSLETTER_PAGE_NAME,
      );
      await submitFormData(NEWSLETTER_FORM_GUID, params);
      setIsSubmitted(true);
      setEmail("");
    } catch {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleChange = ({ value }: { value: string }) => {
    setEmail(value);
    if (errorMessage) setErrorMessage("");
  };

  return {
    email,
    isSubmitting,
    isSubmitted,
    errorMessage,
    handleSubmit,
    handleKeyDown,
    handleChange,
  };
};
